<div class="card">
    <div class="card-body">
        <div *ngIf="isForSystemTest" style="color: red; font-weight: bold; font-size: 16px; margin-bottom: 10px;">
            <a><b>Dieser Mandant ist für Systemtests angelegt!</b></a>
            <br><br>
        </div>
        <form [formGroup]="editTenantForm" novalidate>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field style="width: 0; height: 0;">
                        <input matInput hidden  formControlName="id">
                    </mat-form-field>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['INPUTTENANTNAME'] | translate}}" formControlName="name" readonly>
                    </mat-form-field>
                </div>
            </div> -->
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Scope" formControlName="scopeName" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Frontend URL" formControlName="frontendUrl" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="System Typ" formControlName="systemType" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="systemType === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Mandant" formControlName="wpTenant" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="systemType === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Api Key Inbound" formControlName="wpApiKeyInbound" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="systemType === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Api User" formControlName="wpApiUser" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="systemType === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Api Key" formControlName="wpApiKey" readonly>
                    </mat-form-field>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Max. Anzahl Mitglieder" formControlName="maxUserCount">
                    </mat-form-field>
                </div>
            </div> -->

            <div class="row">
                <div *ngIf="preview">
                    <!-- <h4>Vorschau:</h4> -->
                    <img [src]="preview" alt="Preview" style="margin-left: 16px; margin-top: 8px; max-width: 100px; border:1px solid #ccc;">
                </div>
                <button mat-raised-button class="btn btn-squirrel" style="max-height: 41.15px; margin-top: 6px;margin-left: 16px" (click)="fileInput.click()">Bild hochladen</button>
                <input 
                    #fileInput 
                    type="file" 
                    accept="image/*"
                    (change)="onFileSelected($event)" 
                    style="display:none"
                />
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="Bild in der Ansicht entfernen"
            (click)="removeImage()" >Bild entfernen</button>
            </div>

            <br><br>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
            (click)="cancel()" >Abbruch</button>
            <!-- <span style="flex: 1 1 auto"></span> -->
            <button mat-raised-button type="submit" class="btn btn-squirrel pull-right"
                (click)="editTenant()">{{this.translate.data['MODIFY'] | translate}}</button>
            <div class="clearfix"></div>
        </form>
    </div>
</div> 